import CashierServiceCollection from "../CashierServiceCollection";
import InvoiceItemModel from "../../models/cashier/InvoiceItemModel";

export default class InvoiceItemCollection extends CashierServiceCollection {

  model() {
    return InvoiceItemModel;
  }

}
